import {SelectItem} from 'primeng/primeng'

export interface IDepositsColumn {
    field: string,
    header: string,
    style: any,
    show: boolean,
    sort: boolean,
    editable: boolean,
    checked?: boolean,
    disabled: boolean,
}

export class DepositSearchTableHelper {
    public PotentialDepositSearchColumns: IDepositsColumn[]

    constructor() {
        this.generatePotentialDepositSearchColumns()
    }

    generatePotentialDepositSearchColumns(): void {
        this.PotentialDepositSearchColumns = [
            { field: 'Payer_ShardPayerIdentifier', header: 'Carrier', style: '', sort: true, show: true, editable: false, disabled: false },
            { field: 'Check_CheckNumber', header: 'Check Number', style: '', sort: true, show: true, editable: false, disabled: false },
            { field: 'Check_CheckAmount', header: 'Check Amount', style: '', sort: true, show: true, editable: false, disabled: false },
            { field: 'Deposit_DepositDate', header: 'Deposit Date', style: '', sort: true, show: true, editable: false, disabled: false },
        ]
    }
}



// WEBPACK FOOTER //
// ./src/app/components/deposit-search/deposit-search.tableHelper.ts